import { type Common } from './common.js';
import type * as ProviderNoteField from './models/providerNoteField.js';
import { type StandardNoteFieldWithOverride } from './models/standardNoteField.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(providerUserId: string): Promise<ProviderNoteField.ProviderNoteField[]> {
    const url = this.common.constructPath(`/provider-note-fields`, {
      providerUserId,
    });
    return await this.common.getJSON(url);
  }

  async findAllWithOverride(providerUserId: string): Promise<StandardNoteFieldWithOverride[]> {
    const url = this.common.constructPath(`/provider-note-fields`, {
      providerUserId,
      override: true,
    });
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<ProviderNoteField.ProviderNoteField> {
    const url = this.common.constructPath(`/provider-note-fields/${id}`);
    return await this.common.getJSON(url);
  }

  async create(
    values: ProviderNoteField.CreateValues
  ): Promise<ProviderNoteField.ProviderNoteField> {
    const url = this.common.constructPath(`/provider-note-fields`);
    return await this.common.postJSON(url, values);
  }

  async update(
    id: string,
    values: ProviderNoteField.UpdateValues
  ): Promise<ProviderNoteField.ProviderNoteField> {
    const url = this.common.constructPath(`/provider-note-fields/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<{ success: true }> {
    const url = this.common.constructPath(`/provider-note-fields/${id}`);
    return await this.common.deleteJSON(url);
  }
}
